import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CompanyQineticPaymentSourceService } from 'src/app/core/company-qinetic-payment-source.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import {
  StoreQineticPaymentSource,
  StoreQineticPaymentSourceService,
} from 'src/app/core/store-qinetic-payment-source.service';
import {
  ERROR_QINETIC_PS_NOT_FOUND_CODE,
  ERROR_STORE_QINETIC_PS_NOT_FOUND_CODE,
} from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-stores-payment-methods-dialog',
  templateUrl: './stores-payment-methods-dialog.component.html',
  styleUrls: ['./stores-payment-methods-dialog.component.scss'],
})
export class StoresPaymentMethodsDialogComponent {
  company_id?: string;
  store_id?: string;
  is_qinetic_ps_list_running: boolean = false;
  qinetic_payment_sources?: StoreQineticPaymentSource[];
  payment_source_type?: 'store' | 'company';

  constructor(
    private dialog_ref: MatDialogRef<StoresPaymentMethodsDialogComponent>,
    private store_qinetic_payment_source_service: StoreQineticPaymentSourceService,
    private company_qinetic_payment_source_service: CompanyQineticPaymentSourceService,
    private error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.store_id = data.store_id;
    this.company_id = data.company_id;
  }

  ngOnInit(): void {
    if (this.company_id && this.store_id) {
      this.listStoreQineticPaymentSources(this.company_id, this.store_id);
    }
  }

  onRefresh(): void {
    if (this.company_id && this.store_id) {
      this.listStoreQineticPaymentSources(this.company_id, this.store_id);
    }
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  listStoreQineticPaymentSources(company_id: string, store_id: string): void {
    this.is_qinetic_ps_list_running = true;
    this.store_qinetic_payment_source_service.listStoreQineticPaymentSources(company_id, store_id).subscribe({
      next: repsonse => {
        this.payment_source_type = 'store';
        this.qinetic_payment_sources = repsonse.data;
        this.is_qinetic_ps_list_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code === ERROR_STORE_QINETIC_PS_NOT_FOUND_CODE) {
          this.listCompanyQineticPaymentSources(company_id);
        } else {
          this.dialog_ref.close({ error: processed_error });
          this.is_qinetic_ps_list_running = false;
        }
      },
    });
  }

  listCompanyQineticPaymentSources(company_id: string): void {
    this.is_qinetic_ps_list_running = true;
    this.company_qinetic_payment_source_service.listCompanyQineticPaymentSources(company_id).subscribe({
      next: repsonse => {
        this.payment_source_type = 'company';
        this.qinetic_payment_sources = repsonse.data;
        this.is_qinetic_ps_list_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code != ERROR_QINETIC_PS_NOT_FOUND_CODE) {
          this.qinetic_payment_sources = [];
        } else {
          this.dialog_ref.close({ error: processed_error });
        }
        this.is_qinetic_ps_list_running = false;
      },
    });
  }
}
